import gql from 'graphql-tag';

import cardElementConfigurationDetails from './cardElementConfigurationDetails';
import cardTemplateDetails from './cardTemplateDetails';

const cardDetails = gql`
  fragment cardDetails on Card {
    id
    name
    created_at
    updated_at
    account {
      id
    }
    card_categories {
      records {
        id
        name
        is_active
      }
    }
    card_side_groups(slice: { limit: 9999 }) {
      total
      records {
        id
        side
        name
        asset_image {
          id
          url
        }
        card_sides(slice: { limit: 99 }) {
          total
          records {
            id
            name
            asset_image {
              id
              url
            }
            card_template {
              ...cardTemplateDetails
            }
            card_element_configurations {
              ...cardElementConfigurationDetails
            }
          }
        }
      }
    }
  }
  ${cardTemplateDetails}
  ${cardElementConfigurationDetails}
`;

export default cardDetails;
